import React from 'react';
import { Box, Typography, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';
import './Notfound.css';

const Notfound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box className='notFoundContainer' sx={{ textAlign: 'center', padding: '20px' }}>
        <img src={'/assets/PageNotFoundIcon.svg'} alt="Page Not Found" className='notFoundImage' />
      <Typography variant="h1" gutterBottom className='pageNotFoundTitle'>
        Page not found
      </Typography>
      <Typography variant="body1" gutterBottom className='pageNotFoundDescription'>
        You’re either misspelling the URL or requesting a page that's no longer here.
      </Typography>
      <div className='notFoundButtonContainer'>
        <ReusableButton  onClick={() => navigate('/')}>Back to home</ReusableButton>
      </div>
    </Box>
  );
};

export default Notfound;
